import type {
  ListLayerNodesFilter,
  ListLayerNodesQuery,
} from 'hooks/layerNode/types';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';

export const layerNodesKeys = {
  all: () => ['layer_nodes'] as const,
  list: (query: ListLayerNodesQuery) => {
    const params = buildSearchQueryParams<ListLayerNodesFilter>(query);
    return [...layerNodesKeys.all(), 'list', params] as const;
  },
};
